import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, filter } from 'rxjs/operators';
import * as leads from '@webapp/sdk/leads';
import { Action } from 'redux';
import { ExportLeads } from '../action-creators';
import { EXPORT_LEADS } from '../actions';

export const exportLeadsEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, ExportLeads>(EXPORT_LEADS),
    mergeMap(async (action) => {
        await leads.exportLeads(action.artistId);
    }),
    filter(() => false)
  );